import { IRectangle, List } from '@fluentui/react';
import { ShortInvoiceModel } from '../../models/InvoiceModel';
import InvoiceItemView from './InvoiceItemView';

type InvoiceGridProps = {
    invoices: ShortInvoiceModel[];
    onDetail: (order: ShortInvoiceModel) => void;
}

export default function InvoiceGridView({ invoices, onDetail }: InvoiceGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return invoices.length;
    }

    const onRenderCell = (invoice?: ShortInvoiceModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (invoice == null) return <>empty</>;

        return <div
            key={invoice.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            <InvoiceItemView key={invoice.id} invoice={invoice} onDetail={onDetail} />
        </div>;
    }

    return <div className="ml--20 mr--20">
        <List
            items={invoices}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}